






























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import FormBase from '@/components/helper/form-base.vue';
import ModalView from '@/components/helper/modal-view.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';
import Document from '@/store/entities/extranet/document';

@Component({
    components: { FormBase, ModalView },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.document = Util.extend(true, {}, this.$store.state.document.editModel);
                obj.initForm();
            }
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            } else {
                (this as any).initForm();
            }
        }
    }
})

export default class DocumentForm extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    document: Document = new Document();
    modalShow: boolean = false;
    selected: any = null;
    modalSetting: any = {
        entity: "document",
        titleFull: 'Mover Documento A (Selecciones una carpeta)',
        width: "800px",
        showForm: false,
        persistent: false,
        disabledSave: true
    };

    items = [
        //this.gItem({ type: 'object', prop: 'process_type_id', label: 'Tipo de Proceso', generalType: 'PROCESS', size: 6, disabled: true }),
        this.gItem({ type: 'object', prop: 'dealer_id', label: 'Concesionario', entity: 'dealer', disabled: true, required: true, size: 4 }),
        this.gItem({ type: 'object', prop: 'country_id', label: 'Pais', required: true, size: 4 }),
    ]

    get documents() {
        return this.$store.state.category.list;
    }

    selectFolder(item) {
        this.selected = item[0];
        this.modalSetting.disabledSave = (this.selected == null);
    }

    initForm() {
        this.modalSetting.disabledSave = true;
        this.selected = null;
    }

    async save() {
        if (this.selected != null) {                
            this.document.id = this.document['document_id'];
            this.document.category_id = this.selected;

            await this.$store.dispatch({
                type: 'document/update',
                data: this.document
            });
            this.$emit('save-success', this.document);
            this.cancel();
        }
    }

    cancel() {
        this.$emit('input', false);
    }

    async mounted() {
    }

    async created() {
    }
}
